import React from 'react';

// Orijinal HTML'deki 'about' bölümünün React component'i
// Fonksiyon adını dosya adıyla aynı olacak şekilde 'Hakkimizda' olarak güncelledik
function Hakkimizda() {
  return (
    // section'a ID veriyoruz ki Navbar'dan link verilebilsin
    <section className="section about" id="hakkimizda">
      <div className="container">
        <h2 className="section-title">Hakkımızda</h2>
        <div className="about-card">
          <p>
            Aras Asaf İnşaat olarak, Manisa-Akhisar bölgesinde yılların deneyimi ve güvenilirliğiyle
            inşaat sektöründe hizmet vermekteyiz. Konut projelerinden ticari yapılara, yol inşaatından
            altyapı çalışmalarına kadar geniş bir yelpazede kaliteli ve güvenli yapılar inşa ediyoruz.
            Müşteri memnuniyetini ön planda tutan anlayışımız, modern teknoloji ve uzman kadromuzla
            hayalinizdeki projeleri gerçeğe dönüştürüyoruz. Her projede kalite, güvenlik ve zamanında
            teslim ilkelerimizden asla ödün vermiyoruz.
          </p>
        </div>
      </div>
    </section>
  );
}

// export adını da 'Hakkimizda' olarak güncelledik
export default Hakkimizda;